export const CHECKOUT_URL = 'https://el-metodo-del-futbol.impultienda.ar/checkout'

export const PRODUCT_NAME = 'MEGAPACK ENTRENADOR 360°'

export const WHATSAPP_NUMBER = '5491123745788'

export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  'Hola! Quiero hablar con un asesor sobre el Megapack Entrenador 360°.',
)}`

export const price = {
  now: '$27.999',
  was: '$350.000',
  savings: '$322.001',
  discount: '92%',
}

export const urgency = {
  headline: 'SOLO PARA LOS PRIMEROS 50 PROFES',
  detail: 'Sistema completo + 5 bonos + planificador anual por $27.999.',
  spotsLeft: 12,
  spotsTotal: 50,
  claimedPercent: 76,
}

export const heroSpecs: string[] = [
  '6 tomos completos',
  '5 bonos estratégicos',
  '300+ ejercicios listos para dar',
  '120+ fichas visuales',
  'Baby, futsal y fútbol 11',
]

export const stats: { value: string; label: string }[] = [
  { value: '2.500+', label: 'Profes usándolo en Argentina, Chile, Uruguay y México' },
  { value: '6 + 5', label: 'Tomos y bonos incluidos' },
  { value: '4,9/5', label: 'Puntaje de la comunidad' },
  { value: 'Cada semana', label: 'De baby fútbol a fútbol 11' },
]

export const quickQuotes: { quote: string; author: string }[] = [
  {
    quote:
      'Planifiqué todo el año en una sola noche. Hoy cada práctica tiene un objetivo claro y los chicos no quieren que termine.',
    author: 'Profe Roberto · San Miguel',
  },
  {
    quote:
      'Dejé de perder noches buscando ejercicios en internet. Abro el pack y está todo: ordenado, listo y profesional.',
    author: 'DT Marcos · Rosario',
  },
  {
    quote:
      'Los chicos progresan tres veces más rápido porque por fin siguen una progresión lógica. Me cambió la forma de entrenar.',
    author: 'Profe Sofía · Córdoba',
  },
]

export const pains: string[] = [
  'Perdés 3 horas por semana armando la práctica desde cero',
  'Te quedás sin ideas y repetís los mismos ejercicios una y otra vez',
  'No sabés cómo estructurar una progresión lógica para todo el año',
  'Los chicos se te van del club porque no ven un camino claro',
  'Llegás a la cancha sin plan y con la cabeza en otra cosa',
  'Cambiás tu energía de entrenador por trabajo administrativo',
]

export const systemNumbers: { value: string; label: string }[] = [
  { value: '240+', label: 'Páginas prácticas' },
  { value: '300+', label: 'Ejercicios listos para dar' },
  { value: '120+', label: 'Fichas visuales' },
  { value: '6', label: 'Tomos completos' },
]

export const coverage: string[] = [
  'Baby fútbol: bases y coordinación',
  'Futsal: rotaciones y jugadas',
  'Fútbol 11: táctica y presión',
  'Juego posicional y posesión',
  'Juegos reducidos y competencia',
  'Evaluación y seguimiento del plantel',
]

export const volumes: {
  number: string
  title: string
  body: string
  tags: string
}[] = [
  {
    number: '01',
    title: 'Baby Fútbol · Bases',
    body: '25 ejercicios completos de conducción, control y 1vs1, con progresiones armadas por edad.',
    tags: 'Conducción · Control · 1vs1 · Coordinación',
  },
  {
    number: '02',
    title: 'Futsal · El ajedrez del cemento',
    body: 'Salidas, rotaciones y jugadas de pizarrón explicadas paso a paso para el espacio reducido.',
    tags: 'Salidas · Rotaciones · Laterales · Córners',
  },
  {
    number: '03',
    title: 'Fútbol 11 · Táctico',
    body: '20 ejercicios de presión, transiciones, balón parado y organización defensiva.',
    tags: 'Presión alta · Transiciones · Balón parado',
  },
  {
    number: '04',
    title: 'Fútbol 11 · Juego posicional',
    body: '20 ejercicios de posesión, progresión por bandas, coberturas y finalización.',
    tags: 'Posesión · Rondos · Progresión · Finalización',
  },
  {
    number: '05',
    title: 'El Manual del Profe',
    body: 'Manejo del grupo, charlas técnicas, planillas de evaluación y seguimiento de cada jugador.',
    tags: 'Manejo de grupo · Charlas · Evaluación',
  },
  {
    number: '06',
    title: 'El Planificador Anual',
    body: 'Calendario con las 52 semanas mapeadas, objetivos por mes y controles de avance.',
    tags: '52 semanas · Objetivos · Checkpoints',
  },
]

export const bonuses: {
  name: string
  body: string
  value: string
  cover: string
  alt: string
}[] = [
  {
    name: 'Marca Personal para Entrenadores: Cómo Conseguir Mejores Clubes y Cobrar lo que Valés',
    body: 'Armá tu CV, tus redes y tu presentación para que te vengan a buscar de clubes mejores y puedas cobrar lo que corresponde.',
    value: '$60.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/2zjWgy36QbK7K3egHhk25U/fut_5.webp',
    alt: 'Portada del libro Marca Personal para Entrenadores: Cómo Conseguir Mejores Clubes y Cobrar lo que Valés',
  },
  {
    name: 'La Mente del Capitán: Psicología Deportiva Aplicada al Manejo de Grupos',
    body: 'Cómo dar charlas que ericen la piel, sostener el grupo en la derrota y manejar los egos dentro del plantel.',
    value: '$55.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/2LyK3JeYpjk9tnVtqki16d/fut_4.webp',
    alt: 'Portada del libro La Mente del Capitán: Psicología Deportiva Aplicada al Manejo de Grupos',
  },
  {
    name: 'Primeros Auxilios en Campo: El Protocolo de Emergencia para Entrenadores',
    body: 'Qué hacer, paso a paso, cuando un chico se golpea y no hay médico cerca de la cancha.',
    value: '$40.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/26x7TiSsvuKmgy6Ua32Xfj/fut_3.webp',
    alt: 'Portada del libro Primeros Auxilios en Campo: El Protocolo de Emergencia para Entrenadores',
  },
  {
    name: 'Nutrición de Cancha: Guía de Alimentación para el Futbolista Joven y Amateur',
    body: 'Qué comer antes, durante y después para que los chicos no se "mueran" en el segundo tiempo.',
    value: '$35.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/sbeg7dSKWuRLL5MmE5zbjp/fut_2.webp',
    alt: 'Portada del libro Nutrición de Cancha: Guía de Alimentación para el Futbolista Joven y Amateur',
  },
  {
    name: 'Manual de Gestión de Conflictos y Comunicación Familiar',
    body: 'Cómo hablar con los padres, poner límites claros y que la tribuna te deje trabajar en paz.',
    value: '$45.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/nyoBtSYw1cHEX1Xt2V7E5j/fut_1.webp',
    alt: 'Portada del Manual de Gestión de Conflictos y Comunicación Familiar',
  },
]

export const offerBonusTitles: string[] = bonuses.map((bonus) => bonus.name)

export const offerExtras: string[] = [
  '50 ejercicios listos de fútbol',
  'Acceso de por vida y actualizaciones gratis',
]

export const testimonials: {
  initials: string
  name: string
  role: string
  quote: string
}[] = [
  {
    initials: 'RB',
    name: 'Profe Roberto',
    role: 'Club de barrio · San Miguel',
    quote:
      'Planifiqué todo el año en una noche. Cada práctica tiene un objetivo claro y los chicos llegan antes a la cancha. Me cambió el día a día.',
  },
  {
    initials: 'MC',
    name: 'DT Marcos',
    role: 'Futsal · Rosario',
    quote:
      'Dos meses aplicándolo y el equipo progresó más que en toda la temporada anterior. Las jugadas de lateral se pagan solas.',
  },
  {
    initials: 'ST',
    name: 'Profe Sofía',
    role: 'Escuelita de fútbol · Córdoba',
    quote:
      'Antes perdía horas buscando ideas en internet. Ahora abro el pack y está todo: ordenado, listo y profesional.',
  },
  {
    initials: 'JF',
    name: 'Profe Julián',
    role: 'Coordinador de inferiores · La Plata',
    quote:
      'Las planillas de evaluación me cambiaron la charla con los padres. Hoy les muestro progreso concreto y medible.',
  },
  {
    initials: 'AN',
    name: 'Profe Ana',
    role: 'Fútbol femenino · Mendoza',
    quote:
      'Arranqué sin experiencia y estaba desbordada. Este sistema me dio confianza profesional desde el primer entrenamiento.',
  },
]

export const comparison: { without: string; with: string }[] = [
  {
    without: '100+ horas al año planificando',
    with: '10 minutos por semana · todo listo',
  },
  {
    without: 'Prácticas improvisadas, sin progresión',
    with: '300+ ejercicios con progresión lógica',
  },
  {
    without: 'Los chicos mejoran lento y sin rumbo',
    with: 'Progreso medible y avance claro',
  },
  {
    without: 'Padres preguntando por resultados',
    with: 'Planillas de evaluación e informes listos',
  },
  {
    without: 'Entrar a la cancha sin plan',
    with: 'Cada sesión mapeada y lista para dar',
  },
]

export const faqs: { q: string; a: string }[] = [
  {
    q: '¿Es un libro físico o digital?',
    a: 'Es 100% digital. Acceso inmediato a PDFs y fichas para abrir en el celular en plena cancha, o imprimir lo que quieras.',
  },
  {
    q: '¿Sirve para el nivel de mis jugadores?',
    a: 'Sí. El material va de baby fútbol a fútbol 11, con variantes para subir o bajar la dificultad en cada ejercicio.',
  },
  {
    q: '¿Puedo adaptar los ejercicios a mi grupo?',
    a: 'Todos los ejercicios traen objetivo, desarrollo y variante, justamente para que los ajustes a la cantidad de chicos y al espacio que tengas.',
  },
  {
    q: '¿Sirve para nenas?',
    a: '100%. La táctica y la técnica no tienen género: el sistema se aplica igual en fútbol femenino, mixto o masculino.',
  },
  {
    q: '¿Cómo pago y cómo accedo?',
    a: 'Con Mercado Pago: tarjeta, débito, dinero en cuenta o transferencia. El acceso llega a tu mail apenas se acredita el pago.',
  },
  {
    q: '¿Y si no me convence?',
    a: 'Tenés 7 días. Me escribís por WhatsApp y te devuelvo el 100%, sin preguntas y sin formularios.',
  },
]
